import mitt from 'mitt'
import { WindowEvent } from '@/enums/eventType'

const emitter = mitt()

window.addEventListener(WindowEvent.RESIZE, (e: any) => {
  emitter.emit(WindowEvent.RESIZE, e)
})

export { emitter }
